"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var use_media_query_string_hook_1 = __importDefault(require("../../hooks/use-media-query-string.hook"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
exports.breakpoint = dark_theme_1.default.breakpoints.sm;
exports.mobileBreakPointQuery = "(max-width: " + exports.breakpoint + ")";
exports.Mobile = function (_a) {
    var children = _a.children;
    var isMobile = use_media_query_string_hook_1.default(exports.mobileBreakPointQuery);
    return isMobile ? children : null;
};
exports.default = exports.Mobile;
//# sourceMappingURL=mobile.component.js.map